import { FIRM } from "@/data/content";
import { PageHero, Breadcrumbs, FadeIn } from "@/components/Shared";

const SECTIONS = [
  {
    title: "Regulatory information",
    body: [
      `${FIRM.fullName} is a firm of solicitors authorised and regulated by the Solicitors Regulation Authority (SRA). The SRA's professional rules, including the SRA Standards and Regulations, can be viewed at sra.org.uk.`,
      `Our registered office is ${FIRM.address.join(", ")}.`,
    ],
  },
  {
    title: "Complaints procedure",
    body: [
      "We are committed to providing a high-quality service to every client. If you are unhappy with any aspect of our service or a bill, please raise it with the solicitor handling your matter in the first instance, or write to our Managing Director so that we can investigate and respond promptly.",
      "If we are unable to resolve your complaint within eight weeks, you may be entitled to refer it to the Legal Ombudsman (legalombudsman.org.uk), who deals with complaints about service. Complaints about our professional conduct may be raised with the Solicitors Regulation Authority.",
    ],
  },
  {
    title: "Privacy & data protection",
    body: [
      "We take the confidentiality of our clients extremely seriously. Personal information you provide to us is used only for the purposes of providing legal services, complying with our legal and regulatory obligations, and communicating with you about your matter.",
      "We do not share your information with third parties except where necessary for the conduct of your case or where required by law. You have rights of access, rectification and erasure in respect of your personal data — please contact us to exercise them.",
    ],
  },
  {
    title: "Pricing transparency",
    body: [
      "We act for both privately and publicly funded clients. The basis of our fees is always agreed before work begins, and full details of funding options — including legal aid eligibility — are set out on our Fees & Funding page and explained at your first contact with us.",
    ],
  },
];

export default function RegulatoryInfo() {
  return (
    <main data-testid="regulatory-page">
      <PageHero
        eyebrow="Required information"
        title="Legal & regulatory"
        lead="Regulatory details, our complaints procedure, and how we look after your information."
      />
      <Breadcrumbs items={[{ label: "Legal & Regulatory" }]} />

      <section className="bg-white py-20 sm:py-28 lg:py-32">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          {SECTIONS.map((s, i) => (
            <FadeIn key={i} delay={i * 0.06}>
              <div className="border-b border-slate-200 py-8 first:pt-0" data-testid={`regulatory-section-${i}`}>
                <h2 className="brand-heading text-2xl">{s.title}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="mt-4 leading-relaxed text-slate-600">{p}</p>
                ))}
              </div>
            </FadeIn>
          ))}
        </div>
      </section>
    </main>
  );
}
